<template>
  <span
    v-if="messageSize"
    data-test="scout-history"
  >
    <section class="boss-transmission-history">
      <table class="unstriped boss-table">
        <thead>
          <tr>
            <th
              class="boss-table-head"
              colspan="2"
            >スカウト送信履歴</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="boss-table-data-head">送信日時</td>
            <td
              class="boss-table-data"
              data-test="send-date"
            >{{ sendDate(0) | parseDateFormat }}</td>
          </tr>
          <tr>
            <td class="boss-table-data-head">求人</td>
            <td
              class="boss-table-data"
              data-test="job-title"
            >{{ jobTitle }}</td>
          </tr>
          <tr>
            <td class="boss-table-data-head">件名</td>
            <td
              class="boss-table-data"
              data-test="message-subject"
            >{{ messageSubject(0) }}</td>
          </tr>
          <tr>
            <td class="boss-table-data-head">本文</td>
            <td class="boss-table-data">
              <div class="boss-send-contents">
                <div
                  class="boss-send-text pega-pre-wrap"
                  data-test="message-body"
                  v-html="$sanitize(messageBody(0))"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="boss-table-data-head">スカウト特典</td>
            <td class="boss-table-data">
              <span
                v-for="(favor, i) in specialFavors(0)"
                :key="i"
                v-tooltip="{ content: specialFavorBy(favor.id).description}"
                :data-test="'favor-'+ i"
                class="boss-bonus-check-text boss-check-true"
              >{{ favor.name }}</span>
            </td>
          </tr>

          <template v-if="moreHistory">
            <template v-for="index in messageSize-1">
              <tr :key="'blank-'+index"><td colspan="2" /></tr>
              <tr
                :key="'send-date-'+index"
                data-test="more-history"
              >
                <td class="boss-table-data-head">送信日時</td>
                <td
                  :data-test="'more-history-send-date-'+ index"
                  class="boss-table-data"
                >{{ sendDate(index) | parseDateFormat }}</td>
              </tr>
              <tr :key="'job-title-'+index">
                <td class="boss-table-data-head">求人</td>
                <td class="boss-table-data">{{ jobTitle }}</td>
              </tr>
              <tr :key="'subject-'+index">
                <td class="boss-table-data-head">件名</td>
                <td class="boss-table-data">{{ messageSubject(index) }}</td>
              </tr>
              <tr :key="'body'+index">
                <td class="boss-table-data-head">本文</td>
                <td class="boss-table-data">
                  <div class="boss-send-contents">
                    <div
                      class="boss-send-text pega-pre-wrap"
                      v-html="$sanitize(messageBody(index))"
                    />
                  </div></td>
              </tr>
              <tr :key="'favor-'+index">
                <td class="boss-table-data-head">スカウト特典</td>
                <td class="boss-table-data">
                  <span
                    v-for="(favor, i) in specialFavors(index)"
                    :key="i"
                    v-tooltip="{ content: specialFavorBy(favor.id).description}"
                    :data-test="'more-favor-'+ i"
                    class="boss-bonus-check-text boss-check-true"
                  >{{ favor.name }}</span>
                </td>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
    </section>

    <!-- ▼もっと見るボタン -->
    <div
      v-if="(messageSize > 1) && !moreHistory"
      class="boss-more-button"
    >
      <button
        class="float-center boss-button-center boss-button-large"
        data-test="more-history-button"
        @click="onMoreHistoryClick"
      >もっと見る</button>
    </div>
    <!-- ▲もっと見るボタン -->
  </span>
</template>

<script>
import _ from 'lodash'
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
import util from '@/lib/util'

export default {
  filters: {
    parseDateFormat (val) {
      return (val) ? _.defaultTo(dayjs(val).format('YYYY/MM/DD HH:mm'), '') : ''
    }
  },
  props: {
    contractId: {
      type: Number,
      required: true
    },
    jobId: {
      type: Number,
      required: true
    },
    userId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      apiResource: `/scout/view/scouts/contracts/${this.contractId}/jobs/${this.jobId}/users/${this.userId}/scout`,
      scoutHistory: { messages: {} },
      moreHistory: false
    }
  },
  computed: {
    ...mapGetters({
      specialFavorBy: 'specialFavorBy'
    }),
    sendDate () {
      return (index) => {
        return _(this.scoutHistory.messages).get(`[${index}].insertDate`)
      }
    },
    messageSubject () {
      return (index) => {
        return _(this.scoutHistory.messages).get(`[${index}].subject`)
      }
    },
    messageBody () {
      return (index) => {
        return util.replaceAddressAndUrlLink(_(this.scoutHistory.messages).get(`[${index}].body`))
      }
    },
    specialFavors () {
      return (index) => {
        return _(this.scoutHistory.messages).get(`[${index}].specialFavors`)
      }
    },
    jobTitle () {
      return `求人ID:${_(this.scoutHistory).get('job.id')} ${_(this.scoutHistory).get('job.managementName')}`
    },
    messageSize () {
      return _.size(this.scoutHistory.messages)
    }
  },
  created () {
    this.fetch().then(response => {
      this.$set(this, 'scoutHistory', response.data)
    })
  },
  methods: {
    fetch () {
      return this.$http.secured.get(this.apiResource)
    },
    onMoreHistoryClick () {
      this.moreHistory = true
    }
  }
}
</script>
